import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import CS1 from "../media/Activities/CS/CS1.jpg"
import CS2 from "../media/Activities/CS/CS2.jpg"
import CS3 from "../media/Activities/CS/CS3.jpg"
import CS4 from "../media/Activities/CS/CS4.jpg"
import CS5 from "../media/Activities/CS/CS5.jpg"
import CS6 from "../media/Activities/CS/CS6.jpg"
import CS7 from "../media/Activities/CS/CS7.jpg"
import CS8 from "../media/Activities/CS/CS8.jpg"
import CS9 from "../media/Activities/CS/CS9.jpg"


export default function CSGallery() {
  return (
    <ImageList sx={{ width: 500, height: 500 }} cols={3} rowHeight={164}>
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: CS1,
    title: 'CS1',
  },
  {
    img: CS2,
    title: 'CS2',
  },
  {
    img: CS3,
    title: 'CS3',
  },
  {
    img: CS4,
    title: 'CS4',
  },
  {
    img: CS5,
    title: 'CS5',
  },
  {
    img: CS6,
    title: 'CS6',
  },
  {
    img: CS7,
    title: 'CS7',
  },
  {
    img: CS8,
    title: 'CS8',
  },
  {
    img: CS9,
    title: 'CS9',
  },
];